const CDN = 'https://nsure-ai.cdn.modulify.website/resources'

export const resources = {
    crypto: {
        title: 'Crypto use case',
        description: 'See what adaptive AI does to payment fraud on a crypto onramp.',
        href: `${CDN}/crypto-use-case.pdf`
    },
    gaming: {
        title: 'Gaming use case',
        description: 'See what adaptive AI does to payment fraud in gaming.',
        href: `${CDN}/gaming-use-case.pdf`
    },
    prepaid: {
        title: 'Gift card use case',
        description: 'See what adaptive AI does to payment fraud on prepaid and gift cards.',
        href: `${CDN}/gift-card-use-case.pdf`
    },
    checklist: {
        title: 'Checklist guide for digital fraud prevention',
        description: 'Re-evaluate what you have today.',
        href: `${CDN}/payment-fraud-prevention-checklist-guide.pdf`
    }
}
